<template>
  <div
    class="modal-wrapper modal-wrapper--stretch-vertical"
    ref="modal-wrapper"
  >
    <div class="content cardboard">
      <button
        class="content__close"
        @click="close"
        aria-label="close"
        role="button"
      >
        <CloseAnimation />
      </button>

      <img
        :src="`content/${data.id}/polaroid.jpg`"
        :srcset="`content/${data.id}/polaroid@2x.jpg 2x`"
        :alt="data.alt"
        class="content__image"
      />
      <c-spotify v-if="data.spotify" :id="data.spotify" />
      <c-audio v-if="data.audio" :id="data.id" :text="data.audio" />
      <c-carousel v-if="data.gallery" :id="data.id" :count="data.gallery" />
      <c-youtube v-if="data.youtube" :id="data.youtube" />
      <c-text v-if="data.text">{{ data.text }}</c-text>

      <button class="content__back" @click="close">
        Explore the Polaroids
        <span><ButtonAnimation /></span>
      </button>
    </div>
  </div>
</template>

<script>
import Audio from "@/components/Audio.vue";
import Carousel from "@/components/Carousel.vue";
import Video from "@/components/Video.vue";
import Text from "@/components/Text.vue";
import Spotify from "@/components/Spotify.vue";
import CloseAnimation from "@/components/animations/CloseAnimation.vue";
import ButtonAnimation from "@/components/animations/ButtonAnimation.vue";

export default {
  props: ["data"],
  components: {
    CloseAnimation,
    "c-audio": Audio,
    "c-carousel": Carousel,
    "c-youtube": Video,
    "c-text": Text,
    "c-spotify": Spotify,
    ButtonAnimation,
  },
  mounted() {
    // close modal if clicking outside
    this.$refs["modal-wrapper"].addEventListener("click", (e) => {
      let isOutside = !e.target.closest(".content");

      // Edge case for lottie animations
      if (e.target.localName === "image") isOutside = false;

      if (isOutside) this.close();
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
